<section
    class="flex h-full min-w-0 flex-col p-12"
    [class.items-center]="center()"
    [class.justify-center]="center()"
    [style.background]="background()">
    <ng-content/>
</section>